import { cn } from "@devhop/ui";
import type { LucideIcon } from "lucide-react";

export type OrderDetailMetaItem = {
  icon: LucideIcon;
  label: string;
  value: string;
};

type OrderDetailMetaGridProps = {
  items: OrderDetailMetaItem[];
  className?: string;
};

export function OrderDetailMetaGrid({
  items,
  className,
}: OrderDetailMetaGridProps) {
  if (items.length === 0) return null;

  return (
    <div
      className={cn(
        "grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-2 xl:grid-cols-3",
        className,
      )}
    >
      {items.map((item) => {
        const Icon = item.icon;
        return (
          <div
            key={item.label}
            className="flex items-start gap-2.5 rounded-lg border bg-background/80 p-3"
          >
            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
              <Icon className="h-4 w-4" />
            </div>
            <div className="min-w-0">
              <div className="text-muted-foreground text-xs">{item.label}</div>
              <div className="truncate font-medium text-sm">{item.value}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
